export default __webpack_public_path__ + "static/media/tournamentIcon.6c7948b9.svg";